export enum ErrorCode {
  InvalidWebshop = 'INVALID_WEBSHOP',
  InvalidShopCode = 'INVALID_SHOP_CODE',
  IncompleteLink = 'INCOMPLETE_LINK',
  SaleNotActive = 'SALE_NOT_ACTIVE',
}
